import React, { useContext } from 'react';
import { HelpIcon , Field, FieldLabel, FieldContent } from '@m/alchemy-ui';
import { Tooltip } from '@m/alchemy-ui/esm';
import { getNestedProperty } from '@mdigital/common/dist/utils/object';
import { TextPathPrefixLocalNotification } from '..';
import { TriggerContext } from '../../../../../index';
import { PanelLabel } from '../../../../../StyledTriggeringModal';
import { TargetingActions } from '../../../Actions';
import { getSingleText } from '../../../../../../../../common/utils';
import { StyledLogoImage } from './StyledLogoImage';
import { PanelSubTooltip } from '../../../../../StyledTriggeringModal';
import ResourcesSelect from '../../../../../../ResourcesSelect/ResourcesSelect';

const SUPPORTED_SELECTION_TYPES = ['png', 'jpg', 'jpeg', 'gif'];

export const LogoImage = () => {
  const { triggerDispatch, triggerState, isReadOnly } = useContext(TriggerContext);
  const onSelectedLogoResource = (image) => {
    const payload = {
      name: image.fileName,
      resourceId: image.id,
      url: image.url,
      uuid: null,
    };
    triggerDispatch({ type: TargetingActions.SET_APP_LOGO, payload });
  };

  return (
    <StyledLogoImage>
      <Field>
        <FieldLabel>
          <PanelSubTooltip>
            <PanelLabel>{getSingleText(`${TextPathPrefixLocalNotification}.imageSelection.logoImage`)}</PanelLabel>
            <Tooltip
              trigger={
                <HelpIcon size="12" palette="structural" />
              }
              placement="right"
              contents={getSingleText(`${TextPathPrefixLocalNotification}.imageSelection.appIconTooltip`)}
            />
          </PanelSubTooltip>
        </FieldLabel>
        <FieldContent>
          <ResourcesSelect
            resourceId={getNestedProperty(triggerState, 'trigger.triggerCustomLocalNotificationContract.appIcon.resourceId')}
            placeholder={getSingleText(`${TextPathPrefixLocalNotification}.imageSelection.placeholder`)}
            types={SUPPORTED_SELECTION_TYPES}
            onSelect={onSelectedLogoResource}
            isAlchemyDesign={true}
            isDisabled={isReadOnly}/>
        </FieldContent>
      </Field>
    </StyledLogoImage>
  );
};